var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSendIconWhiteFill = function SvgSendIconWhiteFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72334 28.6424C5.20306 21.4813 12.4134 15.5976 19.1241 18.5235L213.629 103.327C220.819 106.462 220.837 116.654 213.658 119.815L19.1153 205.45C12.4211 208.397 5.1938 202.552 6.67614 195.389L22.6032 118.433C23.4372 114.403 26.8979 111.453 31.0087 111.266L37.7467 110.961L30.8896 110.565C26.8398 110.331 23.4468 107.417 22.6044 103.449L6.72334 28.6424ZM24.0347 31.5736C21.0522 30.2733 17.8476 32.8882 18.5233 36.071L31.6246 97.7833C31.9843 99.478 33.3943 100.749 35.1172 100.931L122.482 110.159C124.177 110.338 124.193 112.8 122.5 113V113L35.1913 120.952C33.4373 121.111 31.9941 122.4 31.6372 124.125L18.4341 187.919C17.7753 191.102 20.9874 193.7 23.9626 192.391L199.183 115.26C202.374 113.856 202.366 109.326 199.17 107.933L24.0347 31.5736Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1172 100.931C33.3943 100.749 31.9843 99.478 31.6246 97.7833L18.5233 36.071C17.8476 32.8882 21.0522 30.2733 24.0347 31.5736L199.17 107.933C202.366 109.326 202.374 113.856 199.183 115.26L23.9626 192.391C20.9874 193.7 17.7753 191.102 18.4341 187.919L31.6372 124.125C31.9941 122.4 33.4373 121.111 35.1913 120.952L122.5 113V113C124.193 112.8 124.177 110.338 122.482 110.159L35.1172 100.931Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendIconWhiteFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send-icon-white-fill.dad5fbb2.svg";
export { ForwardRef as ReactComponent };